import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonReload: 'Reload',
  buttonBack: 'Back',
});
